import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM } from '@sorare/core/src/atoms/typography';
import Bold from '@sorare/core/src/atoms/typography/Bold';

import { formatRules } from 'components/so5/Rules/formatRules';

const Rule = styled.div`
  display: grid;
  grid-template-columns: var(--quadruple-unit) 1fr;
  gap: var(--unit);
  align-items: center;

  &.ftue {
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
  }

  &.minified {
    display: block;
  }
`;

const StyledBodyM = styled(BodyM)`
  .minified & {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

type Props = {
  rule: ReturnType<typeof formatRules>[number];
  ftue?: boolean;
  minified?: boolean;
};

export const ComposeRule = ({ rule, ftue, minified }: Props) => {
  if (!rule.defaultMessage) return null;

  return (
    <Rule key={rule.id} className={classNames({ ftue, minified })}>
      {!minified && <div>{rule.icon}</div>}
      <Vertical gap={0}>
        <StyledBodyM as="p" bold={minified}>
          <FormattedMessage
            {...rule.defaultMessage}
            values={{
              ...rule.values,
              b: Bold,
            }}
          />
        </StyledBodyM>
        {!minified && rule.description && (
          <BodyM as="p" color="var(--c-neutral-600">
            {rule.description}
          </BodyM>
        )}
      </Vertical>
    </Rule>
  );
};
